import { Injectable } from '@angular/core';
import { HrefResolverService } from '@blk/cwp-ng-framework';
import * as get from 'lodash/get';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from './api.service';
import { SearchDocumentResult } from './models';

@Injectable()
export class DocumentService {
	public docIdAndLinkMap: Map<string, any> = new Map<string, any>();

	constructor(private apiService: ApiService, private hrefResolverService: HrefResolverService) { }

	public getDocLink(docIds: Array<string>): Observable<Map<string, any>> {
		return this.apiService.fetchGlsDocuments(docIds).pipe(
			map(glsResult => {
				if (glsResult) {
					glsResult.searchRecords.forEach(record => {
						this.docIdAndLinkMap.set(record.documentId, this.hrefResolverService.getResolvedUrl('literatureUrl') + record.documentPath.replace('/literature', ''));
					});
				}
				return this.docIdAndLinkMap;
			})
		);
	}

	public getDocLinkWithSearchParams(keyword: string, identifierKey: string = 'product'): Observable<SearchDocumentResult[]> {
		return this.apiService.fetchGlsDocuments(null, keyword).pipe(
			map(glsResult => {
				return get(glsResult, 'searchRecords', []).map(record => {
					return {
						identifier: get(record, identifierKey),
						documentPath: this.hrefResolverService.getResolvedUrl('literatureUrl') + record.documentPath.replace('/literature', '')
					};
				});
			})
		);
	}
}
